import { QueryKeys } from "@app/constants/query-keys.ts";
import { useApis } from "@app/data/apis.ts";
import { UpdatePowerBISecretSettingPutModel, UpdatePowerBITenantSettingPutModel } from "@app/data/engine.ts";
import { handleApiError } from "@app/helpers/error-helper.tsx";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useQuery } from "bi-lib";
import { toast } from "react-toastify";

export function usePowerBiSettingsData() {
    const apis = useApis();

    const queryClient = useQueryClient();

    const powerBiSettingsQuery = useQuery({
        queryKey: [QueryKeys.PowerBiSettings],
        queryFn: apis.engine.powerBiSettings.powerBiSettingsList,
    });

    const updatePowerBiTenantMutation = useMutation({
        mutationFn: ({ id, data }: { id: number; data: UpdatePowerBITenantSettingPutModel }) =>
            apis.engine.powerBiSettings.powerBiSettingsTenantUpdate(id, data),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [QueryKeys.PowerBiSettings] });

            toast.success("Power BI tenant updated");
        },
        onError: (error: Error) => handleApiError(error, "Failed to update power BI tenant"),
    });

    const updatePowerBiSecretMutation = useMutation({
        mutationFn: ({ id, data }: { id: number; data: UpdatePowerBISecretSettingPutModel }) =>
            apis.engine.powerBiSettings.powerBiSettingsSecretUpdate(id, data),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [QueryKeys.PowerBiSettings] });

            toast.success("Power BI secret updated");
        },
        onError: (error: Error) => handleApiError(error, "Failed to update power BI secret"),
    });

    return {
        powerBiSettings: powerBiSettingsQuery,

        updatePowerBiTenant: updatePowerBiTenantMutation,
        updatePowerBiSecret: updatePowerBiSecretMutation,
    };
}
